export const INIT_SINGLE_POST_VIEW = "initSinglePostView";
export const INIT_SINGLE_COMMENT_VIEW = "initSingleCommentView";
export const SWITCH_FROM_COMMENT_TO_POST_VIEW = "switchFromCommentToPostView";
export const EXPAND_COMMENT_PARENTS = "expandCommentParents";
export const EDIT_POST = "editPost";
export const DELETE_POST = "deletePost";
export const CLEAR_STATE = "clearState";
